import IGenericError from 'src/Models/Server/IGenericError'
import { ITagVTO } from 'src/Models/Server/Response/Tag/ITagVTO'
import TagController from 'src/Services/ToprCoreApi/Axios/Controllers/TagController'
import { appUiStore } from 'src/Stores/AppUiStore'

export interface IState {
  isSubmitting: boolean
  viewModel: IEditTicketForm
}

export const initialState: IState = {
  isSubmitting: false,
  viewModel: undefined,
}

export interface IEditTicketForm {
  name: string
}

export type Actions =
  | {
      type: 'setIsSubmitting'
      isSubmitting: boolean
    }
  | {
      type: 'initialize'
      viewModel: IEditTicketForm
    }

export const reducer = (state: IState, action: Actions): IState => {
  switch (action.type) {
    case 'initialize': {
      return { ...initialState, viewModel: action.viewModel }
    }
    case 'setIsSubmitting':
      return { ...state, isSubmitting: action.isSubmitting }

    default:
      throw new Error('Invalid Reducer Action')
  }
}

export const reducerActions = (
  state: IState,
  dispatch: (action: Actions) => void
) => {
  return {
    initialize: (editTag: ITagVTO) => {
      dispatch({ type: 'initialize', viewModel: { name: editTag.Name } })
    },
    save: (tagId: number, data: IEditTicketForm, onComplete: () => void) => {
      dispatch({ type: 'setIsSubmitting', isSubmitting: true })

      TagController.TagEdit(tagId, data.name)
        .then(() => {
          onComplete()
          dispatch({ type: 'setIsSubmitting', isSubmitting: false })
        })
        .catch((error: IGenericError) => {
          appUiStore.ShowError(error)
          dispatch({ type: 'setIsSubmitting', isSubmitting: false })
        })
    },
  }
}
